import React, { useEffect, useState, } from 'react'
import { Tooltip } from 'antd';

export default function VeteranStatus(props) {
  const { isVeteran } = props;

  return (
    <>
      {
        isVeteran ?
          <img src="/images/icon-laobing-active.png" style={{ width: 18, height: 22, marginRight: 10 }} /> :
          <img src="/images/icon-laobing.png" style={{ width: 18, height: 22, marginRight: 10 }} />
      }
    </>
  );
}
